// Subitens de um item do carrinho agrupados por etapa (Sabores, Borda, Adicionais…).
// Era um IIFE duplicado na sheet do carrinho e na conferência.
export function agruparEtapas(item, allProds, getItemStepsSummary) {

    if (Array.isArray(item.subitems) && item.subitems.length > 0) {
      const grouped = {}; const order = [];
      item.subitems.forEach((si) => {
        const k = (si.step_name && String(si.step_name).trim()) || "Adicionais";
        if (grouped[k] === undefined) { grouped[k] = []; order.push(k); }
        grouped[k].push(si);
      });
      return order.map((name) => ({
        stepName: name,
        items: grouped[name].map((si, idx) => {
          const lookup = si.product_id ? allProds.find(p => String(p.id) === String(si.product_id)) : null;
          return {
            id: si.product_id || `${name}-${idx}`,
            name: si.nome || si.name || "",
            photo_url: si.photo_url || lookup?.photo_url || null,
            price: si.preco != null ? Number(si.preco) : null,
            qty: si.quantidade || 1,
          };
        }).filter(x => x.name),
      })).filter(s => s.items.length > 0);
    }
    // Fallback: getItemStepsSummary (etapas legado)
    const etapas = getItemStepsSummary(item) || [];
    return etapas.map(e => ({
      stepName: e.etapa,
      items: (e.itens || []).map((nm, i) => {
        const prod = allProds.find(p => (p.name || "").toLowerCase() === String(nm || "").toLowerCase());
        return {
          id: prod?.id || `${nm}-${i}`,
          name: nm,
          photo_url: prod?.photo_url || null,
          price: prod?.sale_price ?? null,
          qty: 1,
        };
      }).filter(x => x.name),
    })).filter(s => s.items.length > 0);
}
